import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import Select               from 'react-select';
import moment               from 'moment';
import Datetime             from 'react-datetime';
import 'moment-timezone';

import 'react-datetime/css/react-datetime.css';
import './styles/date_time_picker';


export default class DateTimePicker extends Component {
  state = {
    timezoneArray: [],
    validDate: null
  }

  componentWillMount () {
    const yesterday     = moment().subtract( 1, 'day' );
    const validDate     = this.props.allowPastDates ? () => true : current => current.isAfter( yesterday );
    const timezoneNames = moment.tz.names();
    const timezoneArray = timezoneNames.map( name => {
      return {value: name, label: name}
    })

    this.setState({validDate, timezoneArray});
  }

  handleUpdateDateTime(selectedDate, selectedTime, selectedZone) {
    selectedZone = selectedZone || moment.tz.guess()
    // TODO: figure out how to not log warnings about invalid moment objects.
    this.props.updateDateTime(selectedDate, selectedTime, selectedZone);
  }

  render () {
    if (!this.props.displayCriterium) { return null }

    const {validDate, timezoneArray} = this.state;
    const {selectedDate, selectedTime, selectedZone } = this.props;

    return (
      <div className="date-time-picker-wrapper">
        <div className='date-picker-container picker-container'>
          <label className='selection-label'>{bfTranslate('Date')}</label>
          <Datetime value={ selectedDate }
                    onChange={ date => {
                      this.handleUpdateDateTime(typeof date == 'string' ? date : date.format('MM/DD/YYYY'), selectedTime, selectedZone);
                    }}
                    inputProps={ {className: 'inputs'} }
                    isValidDate={ validDate }
                    closeOnSelect={ true }
                    timeFormat={ false }
                    utc={ true }
                    className="t-date-selector"/>
          <span className='bff-calendar icon'></span>
        </div>
        <div className='time-picker-container picker-container'>
          <label className='selection-label'>{bfTranslate('Time')}</label>
          <Datetime value={ selectedTime }
                    onChange={ time => {
                      this.handleUpdateDateTime(selectedDate, typeof time == 'string' ? time : time.format('hh:mm a'), selectedZone);
                    }}
                    inputProps={ {className: 'inputs'} }
                    isValidDate={ validDate }
                    closeOnSelect={ true }
                    dateFormat={ false }
                    utc={ true }/>
        </div>
        <div className='timezone-container select-wrapper picker-container'>
          <label className='selection-label'>{bfTranslate('Timezone')}</label>
          <Select value={ selectedZone }
                  onChange={ timezone => this.handleUpdateDateTime(selectedDate, selectedTime, timezone ? timezone.value : timezone) }
                  closeOnSelect={ true }
                  options={ timezoneArray }
                  />
        </div>
      </div>
    )
  }
}

DateTimePicker.defaultProps = {
  allowPastDates: false,
  displayCriterium: true,
  selectedDate: moment().format('MM/DD/YYYY'),
  selectedTime: moment().format('hh:mm a'),
  selectedZone: moment.tz.guess()
}
